import { Button, Flex, Heading, Image, Text } from '@chakra-ui/react';

const TransfersIntroCard = () => {
  return (
    <Flex flexDir="column" gap={4}>
      <Image h="2xs" fit="contain" src="/images/transfer-units-min.png" alt="Transfer units" />
      <Flex flexDir="column" gap={4} alignItems="center">
        <Heading>Move inventory between locations</Heading>
        <Text>Move and track inventory between your business locations.</Text>
        <Text>To create a transfer, you&apos;ll need more than one location.</Text>
        <Button size="xs">Add a location</Button>
      </Flex>
    </Flex>
  );
};

export default TransfersIntroCard;
